RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    models.Widget = Marionette.Dashboard.models.Widget.mixin({
        configurationModel: App.models.WidgetConfiguration,
        mixins: {
            Export: App.mixins.Export,
            Title: App.mixins.Title
        },

        /*
         * Single widget wrapper view - panel with actions outside panel
         */
        getDetailWrapperView: function () {
            return App.views.DetailsLayout;
        },

        getPanelView: function () {
            const me = this;
            return me.panelView;
        },

        getDetailPanelView: function () {
            const me = this;
            return me.detailPanelView;
        },

        getBackPath: function () {
            const me = this;
            return me.curation.getBackPath(me.getProps());
        },

        getBackLinkClassName: function () {
            const me = this;
            return me.curation.getBackLinkClassName();
        },

        getBackLinkName: function () {
            const me = this;
            return me.curation.getBackLinkName();
        },

        hasFooter: function () {
            const me = this;
            return !me.isExporting() && me.hasViewMore();
        },

        getFooterView: function () {
            const me = this;
            return (me.footerView || App.views.PanelFooter);
        },

        // Flag to toggle if widget supports view more
        viewMore: true,

        hasViewMore: function () {
            const me = this;
            return !me.isExporting() && me.viewMore &&
                !me.isFocus() && !me.shouldShowPlanWall();
        },

        viewMorePath: function () {
            const me = this;
            return me.getPath();
        },

        getViewMoreName: function () {
            return 'View More';
        },

        exportFormats: [
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT
        ],

        exportTypes: [
            RivalIQ.enums.exportType.EMAIL,
            RivalIQ.enums.exportType.DOWNLOAD,
            RivalIQ.enums.exportType.SCHEDULE
        ],

        getExportParameters: function (format, overrides) {
            const me = this;

            const props = {};

            if (me.instanceId) {
                props.instanceId = me.instanceId;
            } else {
                props.widgetId = me.widgetId;
                // Serialize definition props b/c we cannot reload them from
                // the configuration since we have no instanceId
                _.extend(props, me.getDefinitionProps());
            }

            return _.extend(props, _.defaults({}, overrides, me.getPropsForFormat(format)));
        },

        getPropsForFormat: function (format) {
            const me = this;

            return _.extend(me.mixins.Export.getPropsForFormat.call(me, format), {
                instanceId: me.instanceId
            });
        },

        getDefinitionProps: function () {
            const me = this;
            // use _.reduce instead of _.omit to ensures we only get ownProperties
            return _.reduce(me.configurationProps, (memo, value, key) => {
                if (key !== 'id') {
                    memo[key] = value;
                }
                return memo;
            }, {});
        },

        toJSON: function () {
            const me = this;

            const props = _.mergeEnumerable(_.assign(me.getDefinitionProps(), _.clone(me.attributes)));

            return {
                instanceId: me.instanceId,
                widgetId: me.widgetId,
                // Dont include id of the widget in model, its noise
                props: _.omit(me.getPropsForSerialization(props), 'id')
            };
        },

        /*
         * Override to modify props before the widget is serialized.
         * For example, exclude a prop from being saved to favorites
         */
        getPropsForSerialization: function (props) {
            return props;
        },

        /*
         *  Override to modify which widget props will be passed back to the widget
         *  on export.
         *  For example, dont display the expanded version of an analyze graph
         *  on export
         */
        getPropsForCurationExport: function () {
            return {};
        },

        supportedProps: {},

        /*
         * Returns true if the provided prop is supported by the widget
         */
        supportsProp: function (prop) {
            const me = this;
            if (_.has(me.supportedProps, prop)) {
                return me.supportedProps[prop];
            }
            return true;
        },

        /*
         * Returns valid prop values for the given prop
         * undefined indicates any value is valid
         */
        getValidPropValues: function (key) {
            const me = this;
            const val = _.get(me.propValues, key);

            if (_.isFunction(val)) {
                return val.call(me);
            }
            return val;
        },

        isPropValueValid: function (key, value) {
            const me = this;
            const valid = me.getValidPropValues(key);

            if (_.isUndefined(valid)) {
                return true;
            }

            return _.includes(valid, value);
        },

        reportDefinition: function () {
            return RivalIQ.apps.Reports.data.reportDefinitions.get(
                RivalIQ.apps.Reports.enums.reportTypes.BARE
            );
        },

        getExportStyles: function () {
            const branding = RivalIQ.state.view.getActiveBranding();
            return RivalIQ.utils.branding.overrideReportStyles(branding);
        },

        getSlides: function (overrides) {
            const me = this;

            const slides = [];

            if (me.curation.widgetShouldIncludeTitleSlide(me)) {
                slides.push(me.curation.getTitleSlide());
            }

            slides.push(me.buildSlide(overrides));

            return slides;
        },

        getSlideDescriptions: _.noop,

        slideType: RivalIQ.enums.slideType.SINGLE,

        buildSlide: function (overrideProps) {
            const me = this;

            // TODO rename slide params and make this more friendly to handling
            // arrays
            function addDescription(elements) {
                const descriptions = me.getSlideDescriptions();

                if (_.size(descriptions)) {
                    _.extend(elements, {
                        square: true,
                        primaryMetric: descriptions[0].name,
                        primaryMetricDescription: descriptions[0].description
                    });

                    if (descriptions[1]) {
                        _.extend(elements, {
                            secondaryMetric: descriptions[1].name,
                            secondaryMetricDescription: descriptions[1].description
                        });
                    }
                }

                return elements;
            }

            return new RivalIQ.apps.Reports.models.Slide({
                style: me.slideType,
                urls: [
                    me.getExportPathObject(RivalIQ.enums.exportFormat.PPT, overrideProps)
                ],
                elements: addDescription({
                    brand: RivalIQ.apps.Reports.models.Slide.brandImages.getSmall()
                }),
                pdfToPngDpiMultiplier: _.result(me, ['pdfToPngDpiMultiplier'])
            });
        },

        getSlideElements: function () {
            const me = this;
            return {
                header: {
                    title: me.getTitle(),
                    subtitle: me.getSubtitle()
                }
            };
        },

        /*
         * Get layout region based on format
         */
        getRegion: function () {
            const me = this;

            const format = me.getProp('format');
            if (format) {
                return me[`${format}Region`] || me.region;
            }

            return me.region;
        },
        getViewTracking: function () {
            const me = this;

            return _.result(me, 'tracking', {
                name: `viewed_${me.curation.getCurationViewTrackingId()}_details_${me.widgetId}`,
                category: 'page_view',
                options: _.omit(me.getProps(), me.stateProps)
            });
        },

        getExportTracking: function (action, format) {
            const me = this;

            const options = _.extend(me.getProps(), {
                action: action,
                format: format
            });

            return {
                name: `exported_${me.curation.id}_details_${me.id}`,
                category: 'export',
                options: options
            };
        },

        getScheduledExportTracking: function (format) {
            const me = this;

            const options = _.extend(me.getProps(), {
                format: format
            });

            return {
                name: `scheduled_exported_${me.curation.id}_details_${me.id}`,
                category: 'export',
                options: options
            };
        },

        stateProps: App.models.Curation.prototype.stateProps,

        processProps: _.identity,

        transformProps: function (props, changed) {
            const me = this;

            if (me.isExporting()) {
                return me.transformExportProps(props, changed);
            }

            return me.processProps(props, changed);
        },

        getConfigurationAttrs: function () {
            const me = this;
            const attrs = Marionette.Dashboard.models.Widget.prototype.getConfigurationAttrs.call(me);
            attrs.definitions = _.result(me, 'widgetDefinitions', []);

            return attrs;
        },

        isCompanySetFilteringDisabled: function () {
            const me = this;
            return Boolean(me.curation.companySets);
        },

        isTimePeriodDisabled: function () {
            const me = this;
            return me.curation.isTimePeriodDisabled();
        },

        dismiss: function (until, state) {
            const me = this;

            // NOTE only if the widget defines an instanceId should we keep track
            // of its dismissal in state/landscape settings
            if (me.instanceId) {
                const widgets = (state || RivalIQ.state.landscape).get('widgets');
                const dismissed = (_.exists(until) ? until : true);

                widgets[me.instanceId] = {
                    dismissed: dismissed
                };
                (state || RivalIQ.state.landscape).set({
                    widgets: widgets
                });
            }

            me.trigger('dismissed');
        },

        isDismissed: function (options) {
            const me = this;
            const state = _.get(options, 'state', RivalIQ.state.landscape);

            if (!me.instanceId) {
                return false;
            }

            // see if this widget has already been hidden.
            const persisted = _.get(state.get('widgets'), me.instanceId, {});

            const dismissed = persisted.dismissed;
            let dismissedUntil = null;

            if (_.exists(dismissed) && !_.isBoolean(dismissed)) {
                dismissedUntil = moment.utc(dismissed);
            }

            // omit if dismissed is true or a valid date in the past
            // NOTE: moment isBefore returns false for invalid dates
            return (dismissed === true ||
                (dismissedUntil && moment.utc().isBefore(dismissedUntil)));
        },

        isRestricted: function () {
            const me = this;
            return me.shouldShowPlanWall();
        },

        shouldShowChannelWall: _.constant(false),

        shouldShowPlanWall: _.constant(false),

        getChannelWallView: function (channel) {
            return RivalIQ.channels.views.ChannelWall.extend({
                source: RivalIQ.data.channels.get(channel).get('source'),
                size: 'small'
            });
        },

        getPlanWallView: function () {
            return RivalIQ.views.PlanRestriction;
        },

        shouldShowExport: function () {
            const me = this;
            return !me.shouldShowPlanWall() && !me.shouldShowChannelWall() && me.getExportFormats().length;
        },

        getExportDropdownView: function () {
            return RivalIQ.apps.Dashboard.views.ExportDropdown;
        },

        getExportDropdown: function (options) {
            const me = this;

            const config = _.defaults({
                model: me
            }, options);

            const View = me.getExportDropdownView();

            return new View(config);
        },

        getColumnWidth: function () {
            const me = this;
            return me.getProp('columnWidth');
        },

        getSize: _.constant(RivalIQ.enums.widgetSize.THIRD_PAGE),

        getWidgetInstanceState: function () {
            const me = this;
            return me.curation?.getWidgetInstanceState && me.curation.getWidgetInstanceState(me.id);
        },

        // This is useful for when you need a handle on the curation. It's not always me.curation; in the dashboards library, when a widget has a child widget,
        // the parent widget is set as the child's curation, not the actual page curation. This method will walk up the tree until if finds the top-most curation.
        getCuration: function () {
            const me = this;

            let curation = me.curation;
            while (curation.curation) {
                curation = curation.curation;
            }

            return curation;
        }
    });

}, window.moment);
